import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { estado_DGII, estado_factura, getLink, getOptionsForDropdown, getVendedoresForDropdown, permisions, renderEstadoBadge, toast } from "../../../utils/helpers";

// COMPONENTS
import Select from "react-select";
import IndexPageLayout from "../../general/CRUDLayout/IndexPageLayout";
import useFilters from "../../../hooks/useFilters";
import Dropdown from "../../general/Dropdown";
import dayjs from "dayjs";
import { apiRequest } from "../../../hooks/apiRequest";
import Modal from "../../general/Modal";
import PinModal from "../../general/PinModal";
import { auth } from "../../../utils/auth";

const NotasCredito = () => {
	const [showCancel, setShowCancel] = useState(false);
	const [showPinReactivar, setShowPinReactivar] = useState(false);
	const [notaReactivar, setNotaReactivar] = useState(null);
	const esAdmin = auth.is("admin") || auth.is("super-admin");
	const [saving, setSaving] = useState(false);
	const [notaCredito, setNotaCredito] = useState({});
	const [triggerRequest, setTriggerRequest] = useState(0);
    const [numeraciones, setNumeraciones] = useState([]);
    const [showInformacionDgiiModal, setShowInformacionDgiiModal] = useState(false);
    const [notaSeleccionada, setNotaSeleccionada] = useState({});
    const [procesando, setProcesando] = useState(false);
    const [vendedores, setVendedores] = useState([]);
    const [numeracionesNota, setNumeracionesNota] = useState([]);

	const { filters, handleFilterChange, filtersQuery } = useFilters({
		buscar: "",
		tipo: "venta",
		desde: dayjs().format("YYYY-MM-DD"),
		hasta: dayjs().format("YYYY-MM-DD"),
		estado: "",
	});

	const TABLE_COLUMNS = [
		{
			title: "NCF/Número",
			tdContent: (row) => {
                const estadoDGII = estado_DGII[row.documento?.legalStatus || 'NOT_SENT'];
                return (<>
                <span>{row.numeracion}</span>
                {row.electronica ? (
                    <>
                        <div className={`dropdown`}>
                            <button className={`badge uppercase badge-${estadoDGII.class}`}>
                                {row.documento ? estadoDGII.label : 'No enviada'} <i className="zmdi zmdi-chevron-down"></i>
                            </button>
                            <div
                                className={`dropdown-menu`}
                            >
                                {row?.documento?.alanube_id && (
                                    <button
                                        className="dropdown-item"
                                        onClick={() => openInformacionDgiiModal(row)}
                                    >
                                        Informacion DGII
                                    </button>
                                )}
                                {row?.documento?.alanube_id && (
                                    <button
                                        className="dropdown-item"
                                        onClick={async () => {
                                            setProcesando(true);
                                            actualizarEstado(row.documento.alanube_id);
                                            setProcesando(false);
                                        }}
                                    >
                                        Actualizar Estado
                                    </button>
                                )}
                                {(row.electronica && !row?.documento) || (row.electronica && row.documento.status === 'FAILED') ? (
                                    <button
                                        className="dropdown-item"
                                    onClick={() => {
                                        setProcesando(true);
                                        reenviarDGII(row.id).then(() => {
                                            setProcesando(false);
                                        })
                                    }}
                                    >
                                        Enviar a la DGII
                                    </button>
                                ) : ""}
                                {row?.documento?.documentStampUrl && (
                                    <a href={row.documento.documentStampUrl} target="_blank" className="dropdown-item">
                                        Consultar Status DGII
                                    </a>
                                )}
                            </div>
                        </div>
                    </>
                ) : ''}
            </>)
            },
		},
		{
			title: "Contacto",
			tdContent: (row) => <span>{row.contacto?.nombre}</span>,
		},
		{
			title: "Fecha",
			tdContent: (row) => (
				<span>{dayjs(row.fecha).format("DD/MM/YYYY")}</span>
			),
		},
		{
			title: "Razón",
			tdContent: (row) => <span>{row.razon}</span>,
		},
		{
			title: "Factura afectada",
			tdContent: (row) => (
				<span>
					{row.tipo === "venta"
						? row.factura?.numero_comprobante
						: row.compra?.ncf || row.compra?.numero}
				</span>
			),
		},
		{
			title: "Total",
			tdContent: (row) => <span>{row.total}</span>,
		},
		{
			title: "Estado",
			tdContent: (row) => <div className="w-100 text-center">
                {renderEstadoBadge(row.estado)} <br/>
                <UltimaActividad actividad={row.actividad} />

                <span className={`badge p-2 mt-1 ${row.cuadre_caja_id ? "badge-success" : "badge-secondary"}`} style={{width: "80px"}}>
                    {row.cuadre_caja_id ? "Cuadrada" : "Sin Cuadrar"}
                </span>
            </div>,
		},
		{
			title: "",
			tdContent: (row) => (
				<Dropdown>
					<Link
						to={getLink(`/imprimir/notas-credito/${row.id}`)}
						target="_blank"
						className="dropdown-item"
						title="Impresión normal"
					>
						Impresión
					</Link>

                    {row?.documento?.documentStampUrl && (
                        <a href={row.documento.documentStampUrl} target="_blank" className="dropdown-item">
                            Consultar Status DGII
                        </a>
                    )}
                    {row?.documento?.pdf && (
                        <a href={row.documento.pdf} className="dropdown-item">
                            Descargar PDF
                        </a>
                    )}

					{
						(row.estado !== "cancelada" && !row.electronica && (
							<>
                                {!row.documento && (
                                    <Link
                                        to={getLink(
                                            `/ingresos/notas-credito/${row.id}/editar`
                                        )}
                                        className="dropdown-item"
                                        title="Editar"
                                    >
                                        Editar
                                    </Link>
                                )}
								<button
									onClick={() => toggleCancelModal(row)}
									className="dropdown-item"
									title="cancelar"
								>
									Cancelar
								</button>
							</>
						))
					}

					{row.estado === "cancelada" && !row.electronica && esAdmin && (
						<button
							onClick={() => {
								setNotaReactivar(row);
								setShowPinReactivar(true);
							}}
							className="dropdown-item"
							title="Reactivar"
						>
							Reactivar
						</button>
					)}

					{row.notaFirmada?.length > 0 && <a
                        href={row.notaFirmada[0].url}
                        className="dropdown-item"
                        target="_blank" rel="noreferrer"
                    >
                        Nota Firmada
                    </a>}
				</Dropdown>
			),
		},
	];

	const toggleCancelModal = (notaCredito) => {
		setShowCancel(true);
		setNotaCredito(notaCredito);
	};

	const cancelNotaCredito = async (notaCreditoID) => {
		setShowCancel((state) => !state);
		setSaving(true);

		const response = await apiRequest(
			null,
			`notas-credito/${notaCreditoID}`,
			"DELETE"
		);

		if (response.success) {
			toast("Nota de Crédito Cancelada", "success");
			setTriggerRequest((state) => state + 1);
			return;
		}
		toast("Error cancelando Nota de Crédito", "error");

		setSaving(false);
	};

	const reactivarNotaCredito = async (notaCreditoID, pin) => {
		const data = new FormData();
		data.append("pin_seguridad", pin);

		const response = await apiRequest(
			data,
			`notas-credito/${notaCreditoID}/reactivar`,
			"POST"
		);

		if (response?.success) {
			toast("Nota de Crédito reactivada", "success");
			setTriggerRequest((state) => state + 1);
			return;
		}

		// 422: motivos de negocio por campo; 403: no es admin.
		const mensaje = response?.data?.message;
		const motivos = mensaje && typeof mensaje === "object"
			? Object.values(mensaje).flat()
			: [mensaje || "Error reactivando Nota de Crédito"];
		motivos.forEach((motivo) => toast(motivo, "error"));
	};

    const reenviarDGII = async (id) => {
        const response = await apiRequest(
            {},
            `alanube/documentos/reenviar/${id}?tipo_documento=nota_credito`,
            'POST'
        );

        if (!response?.data?.id) {
            toast(response?.data || "Error reenviando documento", 'error')
        } else {
            setTriggerRequest((state) => state + 1);
        }
    }

    const actualizarEstado = async (id) => {
        const response = await apiRequest(
            null,
            `alanube/documentos/${id}`,
            'GET'
        );
        if (response?.success) {
            setTriggerRequest((state) => state + 1);
            toast("Estado actualizado", "success");
        } else {
            toast(response?.data || "Error actualizando estado", 'error');
        }
    }

    const openInformacionDgiiModal = (nota) => {
		setNotaSeleccionada(nota);
		setShowInformacionDgiiModal(true);
	};

    useEffect(() => {
        getOptionsForDropdown('numeracion-documentos?tipo_documento=factura_venta').then((data) => {
			setNumeraciones(data);
		});

        getVendedoresForDropdown().then((data) => {
            setVendedores(data);
        });

        // Numeraciones de las propias notas de crédito (B04, E34...).
        getOptionsForDropdown('notas-credito-comprobantes', 'label', 'value').then((data) => {
            setNumeracionesNota(data || []);
        });
    }, []);

	return (
		<>
			<IndexPageLayout
				pageHeaderProps={{
					title: "Notas de Crédito",
					hasButton: false,
					children: <HeaderChildren filtersQuery={filtersQuery} />,
				}}
				filters={{
					children: (
						<Filters
							handleFilterChange={handleFilterChange}
                            numeraciones={numeraciones}
                            numeracionesNota={numeracionesNota}
							filters={filters}
						/>
					),
					// Detrás del botón de filtros avanzados, como en las demás vistas.
					extraFilters: (
						<ExtraFilters
							handleFilterChange={handleFilterChange}
							vendedores={vendedores}
						/>
					),
				}}
				dataUrl={`notas-credito${filtersQuery}`}
				tableColumns={TABLE_COLUMNS}
				triggerRequest={triggerRequest}
                numeraciones={numeraciones}
			/>

            <Modal
                show={showInformacionDgiiModal}
                title={`Informacion de la DGII - ${notaSeleccionada?.numero_comprobante || ''}`}
                size="650px"
                toggle={() => {
                    // setInfoMetodoPago({});
                    setShowInformacionDgiiModal((state) => !state);
                }}
            >
                <h3>DOCUMENTO</h3>
                {notaSeleccionada?.documento ? (
                    <table className="table small" style={{lineHeight:1.2}}>
                        <tbody>
                            <tr>
                                <td><strong className="uppercase">Request ID</strong></td>
                                <td>{notaSeleccionada.documento.alanube_id}</td>
                            </tr>
                            <tr>
                                <td><strong className="uppercase">Estado del Envío</strong></td>
                                <td>
                                    <div>{notaSeleccionada.documento.status}</div>
                                    <small>
                                        {estado_factura[notaSeleccionada.documento.status || "FAILED"].descripcion}
                                    </small>
                                </td>
                            </tr>
                            <tr>
                                <td><strong className="uppercase">Estado DGII</strong></td>
                                <td>
                                    <div>{notaSeleccionada.documento.legalStatus}</div>
                                    <small>
                                        {estado_DGII[notaSeleccionada.documento.legalStatus || 'FAILED']?.descripcion}
                                    </small>
                                </td>
                            </tr>
                            <tr>
                                <td><strong className="uppercase">Código de Seguridad</strong></td>
                                <td>{notaSeleccionada.documento.securityCode}</td>
                            </tr>
                            <tr>
                                <td><strong className="uppercase">Archivos</strong></td>
                                <td>
                                    {notaSeleccionada.documento?.pdf && (
                                        <a href={notaSeleccionada.documento.pdf} target="_blank">PDF</a>
                                    )}
                                    {notaSeleccionada.documento.xml ? ' | ' : ''}
                                    {notaSeleccionada.documento.xml && (
                                        <a href={notaSeleccionada.documento.xml} target="_blank">XML</a>
                                    )}
                                </td>
                            </tr>
                            {notaSeleccionada.documento?.governmentResponse?.error && (
                                <tr>
                                    <td><strong className="uppercase">Error</strong></td>
                                    <td>{notaSeleccionada.documento.governmentResponse?.error}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                ) : (
                    <div>No hay ningun documento registrado.</div>
                )}
                {notaSeleccionada?.cancelacion && (
                    <>
                        <hr />
                        <h3>CANCELACIÓN</h3>
                        <table className="table small" style={{lineHeight:1.2}}>
                            <tbody>
                                <tr>
                                    <td><strong className="uppercase">Fecha</strong></td>
                                    <td>{notaSeleccionada.cancelacion.stampDate}</td>
                                </tr>
                                <tr>
                                    <td><strong className="uppercase">Request ID</strong></td>
                                    <td>{notaSeleccionada.cancelacion?.alanube_id}</td>
                                </tr>
                                <tr>
                                    <td><strong className="uppercase">Estado del Envío</strong></td>
                                    <td>
                                        <div>{notaSeleccionada.cancelacion?.status}</div>
                                        <small>
                                            {estado_factura[notaSeleccionada.cancelacion?.status]?.descripcion}
                                        </small>
                                    </td>
                                </tr>
                                <tr>
                                    <td><strong className="uppercase">Mensaje</strong></td>
                                    <td>
                                        <div>Código: {notaSeleccionada.cancelacion.governmentResponse?.codigo}</div>
                                        <div>Nombre: {notaSeleccionada.cancelacion.governmentResponse?.nombre}</div>
                                        <ul>
                                            {notaSeleccionada.cancelacion.governmentResponse?.mensajes?.map(mensaje => (
                                                <li>{mensaje}</li>
                                            ))}
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td><strong className="uppercase">Archivos</strong></td>
                                    <td>
                                        {notaSeleccionada.cancelacion.xml && (
                                            <a href={notaSeleccionada.cancelacion.xml} target="_blank">XML</a>
                                        )}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </>
                )}
            </Modal>

			<PinModal
				showModal={showPinReactivar}
				close={() => setShowPinReactivar(false)}
				callback={(pin) => reactivarNotaCredito(notaReactivar?.id, pin)}
			/>

			{/* ---CONFIRMACIÓN CANCELAR FACTURA--- */}
			<Modal
				title={`Cancelar Nota de Credito ${notaCredito?.numeracion}`}
				show={showCancel}
				callback={() => cancelNotaCredito(notaCredito?.id)}
				acceptText="Aceptar"
				toggle={toggleCancelModal}
			>
				¿Estás seguro de que deseas cancelar esta nota de credito? (Solo un
				administrador podrá reactivarla luego, con el PIN de la sucursal).
			</Modal>
		</>
	);
};

// Quién editó, canceló o reactivó la nota por última vez, y cuándo. La
// actividad viene de la más reciente a la más antigua.
const UltimaActividad = ({ actividad }) => {
	const ultima = actividad?.[0];
	if (!ultima) return null;

	return (
		<small className="d-block text-muted mt-1">
			{ultima.descripcion}
			{ultima.usuario && ` por ${ultima.usuario}`}
			<br />
			{dayjs(ultima.fecha).format("DD/MM/YYYY hh:mm A")}
		</small>
	);
};

const HeaderChildren = ({ filtersQuery }) => {
	return (
		<>
			<div className="d-inline-block float-right h-100 d-flex align-items-center">
                <div className="dropdown m-r-10 d-none d-lg-inline-block">
                    <button className="au-btn au-btn-icon au-btn-filter">
						<i className="zmdi zmdi-print"></i> Reportes
					</button>
                    <ul
						style={{ right: "0", left: "auto" }}
						className="dropdown-menu"
					>
                        {auth.can(permisions.reporteNotaCredito) && <li>
                            <Link
                                to={getLink(`/imprimir/notas-credito${filtersQuery}`)}
                                target="_blank"
                                className="dropdown-item"
                            >
                                Reporte Notas Credito
                            </Link>
                        </li>}
                        {auth.can(permisions.reporteNotaCreditoDetalleImpuesto) && <li>
                            <Link
                                to={getLink(`/imprimir/notas-credito-detalles${filtersQuery}`)}
                                target="_blank"
                                className="dropdown-item"
                            >
                                Detalle de Impuestos
                            </Link>
                        </li>}
                    </ul>
                </div>
				<Link
					to={getLink(`/ingresos/notas-credito/crear`)}
					className="au-btn au-btn-icon au-btn--green au-btn--small m-r-15"
				>
					<i className="zmdi zmdi-plus" /> Añadir Nota de Crédito
				</Link>
			</div>
		</>
	);
};

const Filters = ({ handleFilterChange, filters, numeraciones, numeracionesNota = [] }) => {
	return (
		<>
			<div className="col">
				<label>Buscar</label>
				<input
					type="search"
					placeholder="Buscar..."
					className="form-control"
					name="buscar"
					onChange={(e) =>
						handleFilterChange("buscar", e.target.value)
					}
				/>
			</div>

			<div className="col-12 col-md-6 col-lg-2">
			<label>Estado</label>
				<Select
					name="estado"
                    isClearable
					isMulti
					onChange={(e) => {
                        handleFilterChange("estado", e);
                    }}
					options={[
						{ value: "completada", label: "Completada" },
						{ value: "cancelada", label: "Cancelada" },
					]}
				/>
			</div>

            <div className="col-12 col-md-6 col-lg-2">
                <label>No. Nota de crédito</label>
                <Select
                    name="numeracion_nota"
                    isClearable
                    isMulti
                    onChange={(values) => handleFilterChange("numeracion_nota", values)}
                    options={numeracionesNota}
                />
            </div>

            {filters.tipo !== 'compra' && (
                <div className="col-12 col-md-6 col-lg-2">
                    <label>No. Factura</label>
                    <Select
                        name="numeracion"
                        isClearable
                        isMulti
                        isDisabled={filters.tipo !== 'venta'}
                        onChange={(values) => handleFilterChange("numeracion", values)}
                        options={numeraciones}
                    />
                </div>
            )}
            {filters.tipo === 'compra' && (
                <div className="col-12 col-md-6 col-lg-2">
                    <label>Tipo Factura</label>
                    <Select
                        name="tipo_factura"
                        isClearable
                        onChange={(e) => handleFilterChange("tipo_factura", e?.value)}
                        options={[
                            {
                                label: "Todas",
                                value: "todas",
                            },
                            {
                                label: "Proforma",
                                value: "proforma",
                            },
                            {
                                label: "Comprobante Fiscal",
                                value: "comprobante",
                            },
                        ]}
                    />
                </div>
            )}
			<div className="col-12 col-md-6 col-lg-2 pr-lg-0">
				<label
					htmlFor="desde"
					style={{ fontSize: "12px", textTransform: "uppercase" }}
				>
					Desde
				</label>
				<input
					type="date"
					name="desde"
					id="desde"
					className="form-control"
					value={filters.desde}
					onChange={(e) =>
						handleFilterChange("desde", e.target.value)
					}
					// disabled={isVendedor()}
				/>
			</div>
			<div className="col-12 col-md-6 col-lg-2 pr-lg-0">
				<label
					htmlFor="hasta"
					style={{ fontSize: "12px", textTransform: "uppercase" }}
				>
					Hasta
				</label>
				<input
					type="date"
					name="hasta"
					id="hasta"
					defaultValue={filters.hasta}
					className="form-control"
					onChange={(e) =>
						handleFilterChange("hasta", e.target.value)
					}
					// disabled={isVendedor()}
				/>
			</div>
		</>
	);
};

const ExtraFilters = ({ handleFilterChange, vendedores }) => {
	return (
		<div className="col-12 col-md-6 col-lg-3">
			<label>Vendedor</label>
			<Select
				name="vendedor"
				isClearable
				onChange={(opcion) => handleFilterChange("vendedor", opcion?.value)}
				options={vendedores}
			/>
		</div>
	);
};

export default NotasCredito;
